import auth from "./auth";
import client from "./client";
import ecommerce from "./ecommerce";
import Category from "./Category";
import Subcategory from "./Subcategory";
import Products from "./Products";
import colorVariant from "./colorVariant";
import Taxes from "./Tax";
import sizeVariant from "./sizeVariant";
import Cart from "./Cart";
import Order from "./Order";
import Coupon from "./Coupon";
import Dispatch from "./Dispatch";
import Address from "./Address";
import banner from "./Banner";
import tags from "./Tags";
import EcomCategory from "./EcomCategory";
import EcomAttributes from "./EcomAttributes";
import studio from "./Studio";
import EcomProduct from "./EcomProduct";
import CmsMenu from "../../Apicall/CmsMenu";
import EcomVariation from "./variation";
import ecomOrder from "./ecomOrder";
import ThreeHerMenu from "../../Apicall/threeherMenu";
import TwoHerMenu from "../../Apicall/twoherMenu";
import menu from "../../Apicall/menu";
import dnsRecord from "../../Apicall/dnsRecord";
import rsu from "../../Apicall/resourceutilization";
import logs from "../../Apicall/logs";
import payment from "./payment";
import transaction from "./transaction";
import ecomCoupon from "./ecomCoupon";
import AgentRouting from "./AgentRouting";
import ecomReview from "./ecomReview";
import Errormanagment from "./Errormanagment";
import Seo from "./Seo";
import agreement from "./agreement";
import ecomOrderReturn from "./ecomOrderReturn";
export default {
  auth: auth,
  client: client,
  ecommerce: ecommerce,
  category: Category,
  subcategory: Subcategory,
  product: Products,
  Tax: Taxes,
  sizeVariant,
  colorVariant: colorVariant,
  cart: Cart,
  order: Order,
  coupon: Coupon,
  dispatch: Dispatch,
  address: Address,
  banner,
  tags,
  EcomCategory,
  EcomAttributes,
  studio: studio,
  EcomProduct,
  studio: studio,
  CmsMenu: CmsMenu,
  EcomVariation,
  ecomOrder,
  ThreeHerMenu,
  TwoHerMenu,
  dnsRecord,
  rsu,
  logs,
  transaction,
  payment,
  ecomCoupon,
  AgentRouting,
  ecomReview,
  Errormanagment,
  Seo,
  agreement,
  ecomOrderReturn,
  menu,
};
